import { NetworkPillNetworks } from '@frontend/ui-library';
import { ApiChainSymbolKeys } from './enums';

export function networkPillMap(network: ApiChainSymbolKeys) {
  const networkMap: Record<ApiChainSymbolKeys, NetworkPillNetworks> = {
    'LN-BTC': 'ln-btc',
    BTC: 'btc',
    ETH: 'eth',
    BASE: 'base',
    MATIC: 'polygon',
    POLYGON: 'polygon',
    BSC: 'bsc',
    ERD: 'erd',
    DASH: 'dash',
    TRX: 'trx',
    BinancePay: 'binancePay',
    WalletConnectPay: 'walletConnectPay',
    SOL: 'solanaPay',
    SOLANA: 'solana',
    SUI: 'sui',
    HEDERA: 'hedera',
  };

  return networkMap[network];
}
